export default __webpack_public_path__ + "static/media/dr-sophie-funny.f739b35a.jpg";